import axios from 'axios';

const API_THROTTLE_TIME = 1000; // 500毫秒，接口调用的最小间隔时间

let lastApiCallTime = null;

const api = axios.create({
  baseURL: 'https://www.sxsjhsyxh.org.cn', // 接口的基础 URL
});

// 添加请求拦截器
api.interceptors.request.use((config) => {
  const now = Date.now(); // 获取当前时间戳
  // 如果上一个接口调用的时间距离现在小于阈值，则延迟当前调用的时间
  if (lastApiCallTime && now - lastApiCallTime < API_THROTTLE_TIME) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(config), API_THROTTLE_TIME - (now - lastApiCallTime)); // 延迟剩余时间
    });
  }
  lastApiCallTime = now; // 记录当前调用的时间
  return config;
});

export default api;

